/**
 * Groups a set of NavItems under an optional uppercase label.
 */
export function NavSection({ label, children }) {
  return (
    <div className="cp-nav-section">
      {label && <div className="cp-nav-section__label">{label}</div>}
      <ul className="cp-nav-section__list">{children}</ul>
    </div>
  );
}
